<template>
  <dialog-editor 
  :item.sync="modalOpen" 
  :name="tag?.tag!==undefined ? 'Редактировать тег' : 'Добавить тег'" 
  width="800"
  :submitText="isValid ? 'Сохранить' :  null" 
  @submit="isValid ? tagAddOrUpdate() : null"
  content-padding-remove>
    <template v-slot:actions>
        <btn-icon-accept v-if="tag?.tag!==undefined" icon="mdi-trash-can-outline" text="Удалить тег?" @accept="tagDelete()"/>
    </template>
    <div v-if="localTag" class="px-3 py-5">
      <simple-date name="Дата начала" :value.sync="localTag.startDate" class="mb-4 full-width" />
      <simple-date name="Дата завершения" :value.sync="localTag.endDate" class="mb-4 full-width" />

      <v-alert
        outlined
        type="warning"
        prominent
        border="left"
        v-if="!isValid"
      >
        Диапазон задан неверно
      </v-alert>
    </div>
  

  </dialog-editor>
</template>

<script>
import Api from "@/Api";
import moment from "moment";
import State from "@/plugins/state";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import SimpleDate from "@/componentsV2/base/Date.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";


export default {
  components: {
    DialogEditor,
    SimpleDate,
    BtnIconAccept
  },
  props: ['tag','entityId','entityType'],
  data: () => ({
    modalOpen: null,
    loadState:new State(),
    deleteState:new State(),
    localTag: null,
    isValid: true
  }),
  watch: {
    tag() {
      if (this.tag!=null) {
        this.modalOpen = true;
        this.localTag = Object.assign({}, this.tag);
        this.localTag.startDate = this.localTag.startDate? this.$tools.date(this.localTag.startDate) : null;
        this.localTag.endDate = this.localTag.endDate ? this.$tools.date(this.localTag.endDate) : null; 
        this.localTag.color = this.tag.color;
      }  
    },
    'localTag.startDate'(){
      this.validation();
    },
    'localTag.endDate'(){
      this.validation();
    },
    modalOpen(v){
      if (v===null)
        this.$emit('update:tag',null)
    }
  },
  methods: {
    tagAddOrUpdate(){
      this.loadState.stateLoading();

      let data = {}
      data.startDate = this.localTag.startDate ? moment(this.localTag.startDate,'DD.MM.YYYY').format('YYYY-MM-DD HH:mm:ss') : null;
      data.endDate = this.localTag.endDate ? moment(this.localTag.endDate,'DD.MM.YYYY').format('YYYY-MM-DD HH:mm:ss') : null;

      if (this.tag?.tag!==undefined) {
        Api.service.tagLink.update(this.localTag.id, data, (v)=> {
          let tag = { 
            id: v.id, 
            startDate: v.startDate, 
            endDate: v.endDate 
          }
          this.$emit('update', tag);
          this.modalOpen = null;
          this.loadState.stateSuccess();
        },()=> {
          this.deleteState.stateError();
        });
      } else {
        
        if (this.entityType==='user')                 
          data.userId = this.entityId
        if (this.entityType==='medPlan')                 
          data.medPlanId = this.entityId

        data.tagId = this.localTag.id;    

        Api.service.tagLink.add(data, (v)=> {  
          let tag = { 
            id: v.id, 
            tag: { 
              id: v.tagId, 
              name: this.localTag.name,
              color: this.localTag.color
            }, 
            startDate: v.startDate, 
            endDate: v.endDate 
          }
          this.$emit('add', tag);
          this.modalOpen = null;
          this.loadState.stateSuccess();
        },()=> {
          this.deleteState.stateError();
        });
      }
    },
    tagDelete(){
      this.deleteState.stateLoading();
      Api.service.tagLink.delete(this.localTag.id, ()=> {
        this.$emit('delete',this.localTag.id);
        this.modalOpen = null;
        this.deleteState.stateSuccess();
      },()=> {
        this.deleteState.stateError();
      });
    },
    validation() {
      this.isValid = true;
      if (this.localTag.startDate&&this.localTag.endDate) {
        const start = moment(this.localTag.startDate,'DD.MM.YYYY')
        const end = moment(this.localTag.endDate,'DD.MM.YYYY')
        if (start.isAfter(end)) {
          this.$store.commit('alertWarning', 'Диапазон задан неверно');
          this.isValid = false 
        }
      }
    }
  }
}
</script>